import { useMutation } from 'react-query';
import { PractitionerRegistrations } from '../../services/PractitionerRegistration';

export const useCreatePractitionerInvitation = () =>
  useMutation((roleId: number) => PractitionerRegistrations.createPractitionerInvitation(roleId));
